module.exports = __webpack_public_path__ + "img/HA2513-01.d262dac9.jpg";